module.exports = __webpack_public_path__ + "static/img/10.30b6c9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10.jpg
// module id = s9X1
// module chunks = 26